export enum RCFieldView {
  Small = 'small',
  Big = 'big',
}
